/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

export function getCustomerName(
  customers: { [id: string]: string } | undefined,
  customerId: number,
): string | undefined {
  if (customers?.[customerId]) {
    return customers[customerId];
  }
  return undefined;
}
